import tourWelcome from './tour-welcome.png'

export default (): React.ReactElement => <img src={tourWelcome} alt="welcome to clanzy tour" />
